import { createApp } from 'vue';
import App from './App.vue';
import VueAgile from 'vue-agile';

export default function init() {
  const elements = document.querySelectorAll('.heroSlider');

  if (elements.length) {
    elements.forEach((element) => {
      const app = createApp(App, {
        ...element.dataset,
      });

      app.use(VueAgile);
      app.mount(`#${element.id}`);
    });
  }
}
